module.exports = "fonts/GilroyLight.woff2";